import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-685 (3.3 turnover).
export const TurnoverScreen = () => (
  <StubScreen id="turnover" heading="Umsatz der letzten 12 Monate" />
);
